import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './chip_in_amount.less'
import Icon from 'components/common/icon'
import DropDown from 'components/common/dropdown'
import Separator from 'components/common/separator'
import StandardError from 'components/common/standard_error'

import MoneyTextBox from 'components/common/money_text_box'

import Checkbox from 'components/common/checkbox'
import { AMOUNT_TYPES, FUNDING_SOURCES } from 'shared/shared_consts'
import { Link } from 'react-router'
import { exitGlimpse } from 'lib/glimpse'
import { routerShape } from 'react-router/lib/PropTypes'

import { getI18n } from 'client/i18n'
import { formatMoney } from 'client/griffin'

const i18n = getI18n('components/chip_in_glimpse/chip_in_amount')

class ChipInAmount extends React.Component {
  static propTypes = {
    currency: PropTypes.string,
    amountType: PropTypes.oneOf(
      Object.keys(AMOUNT_TYPES).map(key => AMOUNT_TYPES[key])
    ),
    title: PropTypes.string,
    fields: PropTypes.object,
    handleSubmit: PropTypes.func,
    anyInactiveFieldsTouchedWithError: PropTypes.bool.isRequired,
    campaignId: PropTypes.string.isRequired,
    fundingSources: PropTypes.object,
    fsLoading: PropTypes.bool,
    router: routerShape.isRequired,
    shouldAutoFocus: PropTypes.bool,
    onChipIn: PropTypes.func.isRequired,
    fundingSourcesError: PropTypes.object,
    onLoadFundingSources: PropTypes.func,
  }

  handleAddBankClick = () => {
    exitGlimpse('chip_in', this.props.router)
  }

  componentDidMount() {
    if (this.props.onLoadFundingSources) {
      this.props.onLoadFundingSources()
    }
  }

  render() {
    const {
      fields: { amount, anonymous, funding },
      currency,
      fundingSources,
      fsLoading,
      handleSubmit,
      anyInactiveFieldsTouchedWithError,
      amountType,
    } = this.props

    if (this.props.fundingSourcesError) {
      return (
        <StandardError
          iconType="error"
          title={i18n('funding_sources_error_title')}
          subtitle={i18n('funding_sources_error_subtitle')}
          onTryAgain={this.props.onLoadFundingSources}
          showButton
        />
      )
    }

    if (!fundingSources) {
      return null
    }

    const hasBankAccount =
      !fsLoading &&
      Object.keys(fundingSources).some(
        key => fundingSources[key].type === FUNDING_SOURCES.BANK_ACCOUNT
      )

    return (
      <div>
        {!fsLoading &&
          (Object.keys(fundingSources).length === 0 ? (
            <div>
              <div styleName="bank-icon">
                <Icon type="bank" iconSize="huge" strokeColor="blue" />
              </div>
              <div styleName="title">{i18n('need_add_bank')}</div>
              <div styleName="subtitle">{i18n('please_add_bank')}</div>
              <Link
                to="/myaccount/wallet"
                target="_blank"
                className="vx_btn vx_btn-block"
                styleName="add-bank-button"
                onClick={this.handleAddBankClick}
              >
                {i18n('add_bank')}
              </Link>
            </div>
          ) : (
            <div>
              <div styleName="campaign-title">{i18n('chip_in')}</div>
              {amountType !== AMOUNT_TYPES.any && (
                <div styleName="text">
                  {i18n(amountType, {
                    amount: formatMoney(currency, amount.initialValue),
                  })}
                </div>
              )}
              <form
                styleName="amount-form"
                onSubmit={handleSubmit(this.props.onChipIn)}
              >
                <MoneyTextBox
                  {...amount}
                  currencyCode={this.props.currency}
                  title={i18n('amount_to_transfer')}
                  autoFocus={this.props.shouldAutoFocus}
                />

                {fundingSources && (
                  <DropDown label={i18n('transfer_from')} formField={funding}>
                    {Object.keys(fundingSources).map(id => {
                      const fs = fundingSources[id]
                      return (
                        <option key={id} value={id} styleName="fs-option">
                          {fs.type === FUNDING_SOURCES.HOLDING
                            ? i18n('paypal_balance', {
                                amount: formatMoney(
                                  fs.balance.currency,
                                  fs.balance.value
                                ),
                              })
                            : fs.type === FUNDING_SOURCES.BANK_ACCOUNT &&
                              `${fs.name} x-${fs.last4}`}
                        </option>
                      )
                    })}
                  </DropDown>
                )}

                {!hasBankAccount && (
                  <a
                    href="/myaccount/wallet"
                    target="_blank"
                    styleName="add-bank-link"
                    onClick={this.handleAddBankClick}
                  >
                    {i18n('plus_bank')}
                  </a>
                )}

                <Separator type="dotted" />
                <div styleName="to-title">{i18n('to')}</div>
                <div styleName="text">{this.props.title}</div>
                <Separator type="dotted" />

                <div styleName="anonymous-checkbox-container">
                  <Checkbox
                    label={i18n('anonymous')}
                    name="anonymous"
                    data-pa-click="anonymousCheckbox"
                    value={!!anonymous.value}
                    onChange={anonymous.onChange}
                    smallText={true}
                  />
                </div>

                <button
                  className={`vx_btn vx_btn-block ${
                    anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
                  }`}
                  disabled={anyInactiveFieldsTouchedWithError}
                >
                  {i18n('transfer_money')}
                </button>
              </form>
            </div>
          ))}
      </div>
    )
  }
}

export default cssModules(ChipInAmount, styles)
